import { SYS_BORDER_RADIUS_MD, SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_50, SYS_SPACE_RELATIVE_XL, } from '@oneaudi/unified-web-alpha-common';
import { Layout, Text } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';
export const CarCardWrapperMainStyles = styled(Layout) `
  flex: 1;

  > * {
    flex: 1;
  }

  .teaser-text {
    margin-top: 15px;
    word-break: break-word;
  }
`;
export const CarCardWrapperStyles = styled(Layout) `
  flex: 1;

  > * {
    flex: ${({ $compare }) => ($compare ? 'none' : '1')};
  }

  .trimline-engine-select-container {
    max-width: ${({ $compare }) => ($compare ? 'auto' : '300px')};
  }

  .trimline-engine-select-disabled-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    > span {
      color: ${(props) => props.theme.sys.color.text.headline.default};
    }
  }

  .trimline-caes-container {
    max-width: ${({ $compare }) => ($compare ? 'auto' : '500px')};
  }

  .trimline-action-container {
    max-width: ${({ $compare }) => ($compare ? 'auto' : '300px')};
    margin-top: ${SYS_SPACE_FIXED_50};
    > button {
      width: 100%;
    }
  }

  .image-container-compare {
    margin-bottom: ${SYS_SPACE_RELATIVE_XL};
    img {
      border-radius: ${SYS_BORDER_RADIUS_MD};
    }
  }

  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
    flex-direction: column;

    .image-container-compare {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
`;
export const CarCardSelectionStyles = styled(Layout) `
  justify-content: left !important;

  .selected-engine-name {
    min-height: 48px;
  }

  .add-to-configuration-button {
    margin-top: auto;
  }
`;
export const WordBreakText = styled(Text) `
  word-break: break-word;
`;
